export const ADD_EXCH_BET = 'ADD_EXCH_BET';
export const REMOVE_EXCH_BET = 'REMOVE_EXCH_BET';
export const SET_EXCH_BET_STAKE = 'SET_EXCH_BET_STAKE';
export const CLEAR_EXCHANGE_BETS = 'CLEAR_EXCHANGE_BETS';
export const BET_ODDS_CHANGE = 'BET_ODDS_CHANGE';
export const FETCH_OPEN_BETS_SUCCESS = 'FETCH_OPEN_BETS_SUCCESS';
export const CLEAR_SUCCESS_BETS = 'CLEAR_SUCCESS_BETS';
export const SET_BETTING_INPROGRESS = 'SET_BETTING_INPROGRESS';
export const PLACE_BET_REQUEST = 'PLACE_BET_REQUEST';
export const PLACE_BET_SUCCESS = 'PLACE_BET_SUCCESS';
export const PLACE_BET_FAILED = 'PLACE_BET_FAILED';
export const BETSLIP_ODDS_CHANGED_MSG = 'BETSLIP_ODDS_CHANGED_MSG';
export const UPDATE_BET_DETAILS = 'UPDATE_BET_DETAILS';
export const UPDATE_BET_SLIP = 'UPDATE_BET_SLIP';
export const ACCEPT_ODDS_CHANGE = 'ACCEPT_ODDS_CHANGE';
